import { MutationTree } from 'vuex';
import { Stripe } from '@stripe/stripe-js';
import { StripeState } from './state';

// eslint-disable-next-line no-shadow
export enum MutationTypes {
  SET_STRIPE = 'Set Stripe Instance',
  SET_STRIPE_PROMISE = 'Set Stripe Promise',
  SET_LOADING = 'Set Loading State',
  SET_ERROR = 'Set Error',
  RESET_STRIPE = 'Reset Stripe State'
}

export const mutations: MutationTree<StripeState> = {
  [MutationTypes.SET_STRIPE](state, stripe: Stripe | null) {
    state.stripe = stripe;
  },

  [MutationTypes.SET_STRIPE_PROMISE](state, promise: Promise<Stripe | null> | null) {
    state.stripePromise = promise;
  },

  [MutationTypes.SET_LOADING](state, isLoading: boolean) {
    state.isLoading = isLoading;
  },

  [MutationTypes.SET_ERROR](state, error: string | null) {
    state.error = error;
    state.isLoading = false;
  },

  [MutationTypes.RESET_STRIPE](state) {
    state.stripe = null;
    state.stripePromise = null;
    state.isLoading = false;
    state.error = null;
  }
};
